import EFPicture from '@elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function P() {
    const { useLang, useRouter, useEffect, useState, gtm, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [gap, setGap] = useState(24);

    const cards: any[] = [
        {
            img: '/responsive/picture/common-products/double_voltage_hub.png',
            name: t('secP_card1_name'),
            link: t('secP_card1_link'),
        },
        {
            img: '/responsive/picture/common-products/deltapro.png',
            name: t('secP_card2_name'),
            link: t('secP_card2_link'),
        },
        {
            img: '/responsive/picture/common-products/PowerInsight.png',
            name: t('secP_card3_name'),
            link: t('secP_card3_link'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resize = () => setGap(window?.innerWidth >= 1440 ? 24 : window?.innerWidth > 1024 ? 20 : 16);
            resize();
            // window?.addEventListener('resize', resize);
            // return () => window.removeEventListener('resize', resize);
        }
    }, []);

    return (
        <section className={`shp2-detail-P shp2-detail-section ${css['shp2-detail-P']}`}>
            <h2 className="title">{t('secP_title')}</h2>
            <Swiper
                className="cards swiper-box"
                modules={[Navigation]}
                // centeredSlides={true}
                spaceBetween={gap}
                slidesPerView={'auto'}
                initialSlide={0}
                navigation={true}
            >
                {cards?.map((card: any, k: number) => (
                    <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                        <div className="card-img">
                            <EFPicture src={card?.img} alt={card?.name} />
                        </div>
                        <p className={`card-name`}>{card?.name}</p>
                        <Link
                            className="card-link"
                            href={card?.link}
                            target={card?.link.startsWith('http') ? '_blank' : '_self'}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'buy',
                                product_name: card?.name,
                                position: 'Product Preview_Accessories',
                            }}
                        >
                            {t('common_learn_more')}
                        </Link>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
}
